export const iconButtonClass =
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium " +
  "ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 " +
  "focus-visible:ring-[#113F67] focus-visible:ring-offset-2 disabled:pointer-events-none " +
  "disabled:opacity-50 h-8 w-8 md:h-10 md:w-10 text-[#34699A] hover:bg-[hsl(210_40%_96%)] " +
  "hover:text-[#113F67]";

export const menuContentClass =
  "absolute right-0 top-full mt-1 z-50 w-56 min-w-[8rem] overflow-hidden rounded-md border " +
  "border-[hsl(214_32%_91%)] bg-white p-1 text-[hsl(222_84%_5%)] shadow-md";

export const menuItemClass =
  "relative flex w-full cursor-default select-none items-center gap-2 rounded-[4px] px-2 py-1.5 " +
  "text-sm outline-none transition-colors hover:bg-[hsl(210_40%_96%)] " +
  "hover:text-[hsl(222_84%_5%)] focus:bg-[hsl(210_40%_96%)] focus:text-[hsl(222_84%_5%)] " +
  "disabled:pointer-events-none disabled:opacity-50";

export const menuSeparatorClass = "-mx-1 my-1 h-px bg-[hsl(210_40%_96%)]";
